import React, { useContext, useState } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import { SidebarContext } from "context/SidebarContext";
import { IoIosClose } from "react-icons/io";
import CommonCloseBtn from "components/CloseButton/CommonCloseButton";
const ViewModal = ({ id, title, data }) => {
  const { isViewModalOpen, closeModal } = useContext(SidebarContext);
  var result = data.find((item) => item.va_id === id);

  const style = `{
    .custom-modal button {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 16px;
      color: #333;
      outline:none !important;
    }
    .custom-modal button:hover {
      color: #FF0000 !important; 
      outline:none;
      
    } .custom-modal button:focus {
      color: #FF0000 !important; 
      outline:none; 
    }
   .custom-modal {
 
  overflow-y-auto; /* Enable scrolling if the content overflows */
}
    
    `;
  const renderImage = (image, index) => (
    <img
      key={index}
      style={{
        objectFit: "contain",
        width: "100px",
        height: "100px",
        margin: "5px",
        cursor: "pointer",
      }}
      src={`${process.env.REACT_APP_API_IMAGE_URL}${image}`}
      alt={`Bill ${index + 1}`}
    />
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const openZoomModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeZoomModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };
  return (
    <>
      <style>{style}</style>

      <Modal
        className="relative bg-white dark:bg-gray-700 dark:text-white w-1/2 rounded-lg"
        isOpen={isViewModalOpen}
        onClose={() => {
          closeModal();
        }}
      >
        <ModalBody className="custom-modal" style={{ margin: "0" }}>
          <CommonCloseBtn onClose={closeModal}/>
          <h2 className="text-center font-bold text-lg">
            Purchase Bill Details
          </h2>
          {/* Tab Content */}
          <div
            className="max-h-96 overflow-y-auto p-5"
            style={{ maxHeight: "60vh", scrollbarWidth: "thin" }}
          >
            <dl className="border rounded-lg border-gray-300 dark:border-gray-500 text-sm dark:text-white">
              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  Reference Number
                </dt>
                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20 ">
                  {result?.ref_no}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  Client Name
                </dt>
                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                  {result?.client_name}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  Start Date
                </dt>
                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                  {result?.start_date}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  End Date
                </dt>
                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                  {result?.end_date}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  Arrival City
                </dt>
                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                  {result?.arrival}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  Departure City
                </dt>
                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                  {result?.departure}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  Vendor Name
                </dt>
                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                  {result?.vendor_name}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  Vehicle Type
                </dt>
                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                  {result?.vehicle_type}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  Payment Date
                </dt>
                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                  {result?.payment_date}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  Paid Status
                </dt>
                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                  {result?.bill_status === "Paid"
                    ? "Paid"
                    : result?.bill_status === "Partially Paid"
                      ? "Partially Paid"
                      : "UnPaid"}
                </dd>
              </div>
              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  Bill Amount
                </dt>
                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                  {result?.bill_amount}
                </dd>
              </div>
              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  Remark
                </dt>
                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                  {result?.remark}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  Bill Image
                </dt>
                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                  {/* {result?.bill_images && Array.isArray(result.bill_images)
										? result.bill_images.map((image, i) =>
												renderImage(image, i)
										  )
										: result?.bill_images
										? result.bill_images
												.split(',')
												.map((image, i) => renderImage(image, i))
										: null} */}
                  {result?.bill_images?.map((item, index) => {
                    return (
                      <img
                        style={{
                          objectFit: "contain",
                          width: "100px",
                          height: "100px",
                          margin: "5px",
                          cursor: "pointer",
                        }}
                        key={index}
                        src={`${process.env.REACT_APP_API_IMAGE_URL}${item}`}
                        alt={`Bill ${index + 1}`}
                        onClick={() => openZoomModal(item)}
                      />
                    );
                  })}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  Updated Date
                </dt>
                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                  {result && result["bill_added_date"]
                    ? new Intl.DateTimeFormat("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                        second: "numeric",
                        hour12: true,
                      }).format(new Date(result["bill_added_date"]))
                    : ""}
                </dd>
              </div>
            </dl>
          </div>
          {isModalOpen && (
            <div
              className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
              onClick={(e) => {
                // Close modal if clicking on the backdrop
                if (e.target === e.currentTarget) {
                  closeZoomModal();
                }
              }}
            >
              <div className="bg-white dark:bg-gray-600 p-4 rounded-lg max-w-md w-full relative">
                <button
                  onClick={closeZoomModal}
                  className="viewModelBoxCloseBtn bg-white dark:bg-gray-600 dark:text-white absolute top-2 right-2 text-2xl"
                >
                  <IoIosClose />
                </button>

                <img
                  src={process.env.REACT_APP_API_IMAGE_URL + selectedImage}
                  alt="Selected Company Logo"
                  className="w-full h-auto rounded-lg"
                />
              </div>
            </div>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default React.memo(ViewModal);
